export const FETCH_EVALUATIONTYPES_REQUEST = 'FETCH_EVALUATIONTYPES_REQUEST';
export const FETCH_EVALUATIONTYPES_SUCCESS = 'FETCH_EVALUATIONTYPES_SUCCESS';
export const FETCH_EVALUATIONTYPES_FAILURE = 'FETCH_EVALUATIONTYPES_FAILURE';